import React from "react";
import { ExternalLink } from "lucide-react";
import FavHeart from "./FavHeart";
import ShareButton from "./ShareButton";
import CommentButton from "./CommentButton";
import { formatDate } from "../lib/format";

export default function NewsCard({ article }) {
  const { id, title, url, image_url, news_site, summary, published_at } = article;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer"
      className="sat-surface sat-brackets group block relative overflow-hidden transition-all hover:sat-box-glow"
      data-testid={`news-card-${id}`}>
      <div className="grid grid-cols-1 md:grid-cols-[240px_1fr] gap-0">
        <div className="h-40 md:h-full min-h-[160px] bg-black overflow-hidden relative">
          {image_url ? (
            <img src={image_url} alt={title} loading="lazy"
              className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-[color:var(--sat-border-bright)] font-mono">NO SIGNAL</div>
          )}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/60 md:to-transparent md:to-black/40" />
        </div>
        <div className="p-5 flex flex-col gap-3">
          <div className="flex items-center justify-between gap-2">
            <span className="sat-label sat-cyan">{news_site || "SPACE NEWS"}</span>
            <div className="flex items-center gap-2">
              <CommentButton targetKind="news" targetId={String(id)} title={title} size={12} testid={`news-comments-${id}`} />
              <ShareButton url={url} title={title} size={12} testid={`news-share-${id}`} />
              <FavHeart kind="news" ref_id={id} title={title} image={image_url} payload={{ url, news_site }} size={13} />
              <ExternalLink size={12} className="text-[color:var(--sat-text-dim)] group-hover:text-[color:var(--sat-cyan)] transition-colors" />
            </div>
          </div>
          <h3 className="font-display font-bold text-lg leading-tight group-hover:text-[color:var(--sat-cyan)] transition-colors">
            {title}
          </h3>
          {summary && <p className="text-sm text-[color:var(--sat-text-dim)] line-clamp-2">{summary}</p>}
          <div className="sat-label mt-auto pt-2">{formatDate(published_at)}</div>
        </div>
      </div>
    </a>
  );
}
